var include_line_twitter_bnr = `
<div class="contents-wrap mt100">
	<div class="grid-wrapper grid-wrapper--visible">
		<div class="grid-sns">
			<div class="grid-sns-item">
					<a href="https://line.me/R/ti/p/@7card?from=page&openQrModal=true&searchId=7card" target="_blank" class="campaign-banner">
						<img src="/material/img/common/bnr/bnr_sns_line.png" alt="LINE 友だち登録はこちら!">
					</a>
			</div>
			<div class="grid-sns-item">
					<a href="https://twitter.com/nanacoPR" target="_blank" class="campaign-banner">
						<img src="/material/img/common/bnr/bnr_sns_twitter.png" alt="nanaco twitter フォローはこちら!">
					</a>
			</div>
		</div>
	</div>
</div>
`;
